module.exports = __webpack_public_path__ + "img/el-cuento.cc703a76.png";